import app from 'app';
import templateUrl from './fileList.html';
import './fileList.scss';
import _ from 'lodash';

import '@collectivehealth/dls-icons/dist/es/elements/dls-icon-circle-check';
import '@collectivehealth/dls-icons/dist/es/elements/dls-icon-circle-x';
import '@collectivehealth/dls-icons/dist/es/elements/dls-icon-refresh';
import '@collectivehealth/dls-icons/dist/es/elements/dls-icon-trash-can';

function FileList(
  SubmitClaimBillUploadConstants,
  SubmitClaimBillUploadService
) {
  const FileList = this;

  FileList.deleteItem = function (index) {
    if (index > -1) {
      FileList.files.splice(index, 1);
    }
    FileList.showMaxFilesError = FileList.files.length > FileList.maxFiles;
  };

  FileList.hasError = function (file) {
    return (
      file.status !== SubmitClaimBillUploadConstants.status.UPLOADING &&
      file.status !== SubmitClaimBillUploadConstants.status.UPLOADED
    );
  };

  FileList.statusKey = function (status) {
    return _.findKey(
      SubmitClaimBillUploadConstants.status,
      (x) => x === status
    );
  };

  FileList.allowRetry = function (file) {
    return file.status === SubmitClaimBillUploadConstants.status.FAILED;
  };

  FileList.retryUpload = SubmitClaimBillUploadService.uploadFile;
}

app.component('fileList', {
  bindings: {
    files: '=',
    maxFiles: '<',
    showMaxFilesError: '=',
  },
  controller: FileList,
  controllerAs: 'FileList',
  templateUrl,
});

export default 'fileList';
